import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { update, nextPage } from 'actions/onboarding';
import H1 from 'components/deprecated/legacyElements/H1';
import styles from './style.module.scss';

export class BudgetPage extends PureComponent {
  static propTypes = {
    update: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    totalSquareFeet: PropTypes.number.isRequired,
    budgetPsf: PropTypes.number.isRequired,
    budgetMonthly: PropTypes.number.isRequired,
  };

  onChange = (evt) => {
    this.props.update({
      [evt.target.name]: evt.target.value,
    });
  };

  onKeyDown = (evt) => {
    if (evt.keyCode === 0x0d) {
      // Enter key
      this.props.nextPage();
    }
  };

  render() {
    return (
      <div>
        <H1>
          Based on your size and location, here&rsquo;s a budget estimate.
        </H1>
        <h3>Recommended Budget for ~{this.props.totalSquareFeet} sf</h3>
        <p className={styles.budgetEstimate}>
          <span className={styles.nowrap}>
            $
            <input
              type="number"
              min={0}
              value={Number(this.props.budgetPsf).toString()}
              name="budgetPsf"
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
            />
            &nbsp;psf /
          </span>
          <span className={styles.nowrap}>
            $
            <input
              type="number"
              min={0}
              value={Number(this.props.budgetMonthly).toString()}
              name="budgetMonthly"
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
            />
            &nbsp;monthly
          </span>
        </p>
        <p className="micro">
          * Base rent only. Estimate does not include additional expenses like
          utilities or building maintenance fees.
        </p>
        <aside className={styles.infoAside}>
          <h4>Budget Information</h4>
          <p>
            The industry quotes pricing on a per square foot per year basis.
            Here we show on a monthly basis as well. These numbers are based on
            the average prices of the locations you have chosen.
          </p>
        </aside>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    budgetPsf: state.onboarding.budgetPsf,
    budgetMonthly: state.onboarding.budgetMonthly,
    totalSquareFeet: state.onboarding.totalSquareFeet,
  }),
  {
    update,
    nextPage,
  }
)(BudgetPage);
